import { render, staticRenderFns } from "./AppLookupField.vue?vue&type=template&id=736ec534&"
import script from "./AppLookupField.vue?vue&type=script&lang=js&"
export * from "./AppLookupField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports